import { render, staticRenderFns } from "./Agree21ArchiveDialog.vue?vue&type=template&id=16e98fb4&"
import script from "./Agree21ArchiveDialog.vue?vue&type=script&lang=js&"
export * from "./Agree21ArchiveDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QSpace,QBtn,QForm,QSelect,QToggle,QInput,QSeparator,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QSpace,QBtn,QForm,QSelect,QToggle,QInput,QSeparator,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
